// import { _ } from 'utils'
import { createRoute } from 'utils/routes'
import Organization from './Organization'

export default {
    organization: createRoute<{ organizationId: string }>({
        path: '/organization/:organizationId',
        component: Organization,
        exact: true,
        context: 'organization',
    }),
}
